var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 92,
    viewBox: "0 0 131 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_1491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4678 46.2339H32.5361V88.2697H35.4678V46.2339Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4986 46.2339H96.5669V88.2697H99.4986V46.2339Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4162 42.8124H99.1533C99.7766 42.8124 100.394 42.9351 100.97 43.1736C101.545 43.4121 102.069 43.7617 102.509 44.2024C102.95 44.6431 103.3 45.1663 103.538 45.7422C103.777 46.318 103.899 46.9352 103.899 47.5584V48.1884H26.6703V47.5584C26.6703 46.2997 27.1703 45.0926 28.0603 44.2026C28.9504 43.3126 30.1575 42.8125 31.4162 42.8125V42.8124Z",
    fill: "#DFE6F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.2005 42.8124H98.9376C99.5609 42.8124 100.178 42.9351 100.754 43.1736C101.33 43.4121 101.853 43.7617 102.294 44.2024C102.734 44.6431 103.084 45.1663 103.322 45.7422C103.561 46.318 103.684 46.9352 103.684 47.5584V48.1884H26.4546V47.5584C26.4546 46.2997 26.9546 45.0926 27.8446 44.2026C28.7347 43.3126 29.9418 42.8125 31.2005 42.8125V42.8124Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4162 41.8329H99.1533C100.412 41.8329 101.619 42.333 102.509 43.223C103.399 44.113 103.899 45.3202 103.899 46.5788V47.2088H26.6703V46.5788C26.6703 45.3202 27.1703 44.113 28.0603 43.223C28.9504 42.333 30.1575 41.8329 31.4162 41.8329Z",
    fill: "#DFE6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0337 81.1813V78.2496H34.4902V81.1813H98.0337Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6657 68.011H8.10071V91.3479H10.6657V68.011Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9245 68.011H28.3595V91.3479H30.9245V68.011Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.978 64.1647C32.978 65.7223 27.6972 66.9863 21.1822 66.9863C14.6673 66.9863 9.64319 65.7244 9.64319 64.1647C9.64319 62.605 14.6674 61.3431 21.1822 61.3431C27.697 61.3431 32.978 62.6137 32.978 64.1647Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04932 64.1626H32.9753V66.514C32.9753 67.1148 32.7366 67.6909 32.3118 68.1157C31.887 68.5405 31.3109 68.7791 30.7102 68.7791H9.93186C8.90202 68.7791 7.91435 68.37 7.18614 67.6418C6.45793 66.9136 6.04883 65.9259 6.04883 64.8961L6.04932 64.1626Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47725 37.1801L2.03274 37.0547C2.42339 36.9665 2.83307 37.0371 3.17165 37.251C3.51024 37.4649 3.74999 37.8045 3.83817 38.1952L10.5632 67.9878L9.72164 68.1778C9.01509 68.3373 8.27412 68.2096 7.66172 67.8228C7.04933 67.4359 6.61567 66.8217 6.45614 66.1152L0.332484 38.9865C0.288739 38.7927 0.283666 38.5922 0.317556 38.3964C0.351445 38.2007 0.423631 38.0135 0.529977 37.8457C0.636322 37.6779 0.774737 37.5327 0.937289 37.4185C1.09984 37.3043 1.28333 37.2233 1.47725 37.1801Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.333 91.7621H122.898V68.4251H120.333V91.7621Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.075 91.7621H102.64V68.4251H100.075V91.7621Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0254 64.579C98.0254 66.1366 103.306 67.4006 109.821 67.4006C116.336 67.4006 121.36 66.1387 121.36 64.579C121.36 63.0192 116.334 61.7508 109.821 61.7508C103.309 61.7508 98.0254 63.0214 98.0254 64.579Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.067 69.1951H100.288C99.6875 69.1951 99.1113 68.9565 98.6865 68.5317C98.2618 68.1069 98.0231 67.5308 98.0231 66.93V64.5786H124.95V65.3121C124.95 66.3419 124.541 67.3296 123.812 68.0578C123.084 68.786 122.097 69.1951 121.067 69.1951Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.282 68.5909L120.44 68.401L127.166 38.6041C127.254 38.2135 127.494 37.8739 127.833 37.66C128.171 37.4461 128.581 37.3755 128.971 37.4637L129.527 37.5891C129.918 37.6773 130.257 37.917 130.471 38.2556C130.685 38.5942 130.756 39.0039 130.668 39.3945L124.543 66.5272C124.384 67.233 123.951 67.8468 123.339 68.2337C122.728 68.6206 121.988 68.7491 121.282 68.5909Z",
    fill: "#2B2B2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_1491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131,
    height: 91.7621,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailable);
export default __webpack_public_path__ + "static/media/available.c8166175f969cc2ee8af9f219398e306.svg";
export { ForwardRef as ReactComponent };